import React from 'react';
import { Box, Grid } from '@mui/material';
import DateRangeFilter from './DateRangeFilters';
import SearchFilter from './SearchFilter';

const DraftDocumentListFilters = ({
  selectedFilter,
  filters,
  onDateRangeChange,
  onSearchChange,
  onFilterChange,
  searchTerm,
  onSearchKeyPress,
}) => {
  const searchFilters = filters.filter((filter) => filter.type === 'search');
  return (
    <Grid item xs={12} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid container spacing={1}>
        <DateRangeFilter onChange={onDateRangeChange} />
      </Grid>
      <Grid item>
        <Box display="flex" gap={1} justifyContent="flex-end">
          {searchFilters.map((filter) => (
            <SearchFilter
              key={filter.type}
              filter={filter}
              selectedFilter={selectedFilter}
              onFilterChange={onFilterChange}
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              onSearchKeyPress={onSearchKeyPress}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default DraftDocumentListFilters;
